<template>
  <image
    class="flex size-10 cursor-pointer items-center justify-center rounded-full transition-opacity duration-300"
    :class="{ 'opacity-40': isDimmed }"
    @click="onClick"
  >
    <img class="marker size-10" :src="icon" :alt="props.feature.properties?.['icon-name'] + ' icon'" />
  </image>
</template>

<script setup lang="ts">
import { HazardType, isInSelectedAnnouncement, SelectedHazardViewType, useHazardsStore } from '@/features/hazards';
import { HAZARD_MARKERS } from '@/features/hazards/constants';
import { Feature, GeoJsonProperties, Geometry } from 'geojson';
import { Marker } from 'mapbox-gl';
import { computed } from 'vue';

const hazardsStore = useHazardsStore();

const props = defineProps<{
  marker: Marker;
  feature: Feature<Geometry, GeoJsonProperties>;
}>();

const icon = HAZARD_MARKERS[props.feature.properties?.['icon-name'] as keyof typeof HAZARD_MARKERS];

/** Dimmed when another announcement is selected, so the selected announcement's markers stand out. */
const isDimmed = computed(() => !isInSelectedAnnouncement(props.feature.properties, hazardsStore.selectedAnnouncement));

const onClick = async (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();

  const {
    id: hazardId,
    entityType: hazardType,
    eventId,
    featureId,
  } = props.feature.properties as { eventId: string; id: string; entityType: HazardType; featureId: string };

  hazardsStore.toggleSelectHazard({ hazardId, eventId, hazardType, featureId, viewType: SelectedHazardViewType.Popup });
};
</script>
